module.exports = __webpack_public_path__ + "static/media/imac-slider.1c905857.png";